import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { State } from "common/types/redux";

import { hasLiveSubscription } from "seneca-common/features/subscriptions/state";
import { getUserAccountType } from "seneca-common/features/user/state";
import { toJS } from "seneca-common/utils/components/toJS";

import { isPlurallApp } from "features/plurall";
import { getHelpLinkRegionCode, getRegion } from "features/regions/selectors";
import { signOut } from "features/user";
import {
  getNavbarName,
  isSchoolParent,
  isSchoolTeacher
} from "features/user/selectors";

type StateProps = {
  name: string;
  userAccountType: string;
  showRegionLink: boolean;
  hasLiveSubscription: boolean;
  isTeacher: boolean;
  isParent: boolean;
  locale: string;
  region: string;
};

type DispatchProps = {
  signOut: () => void;
};

export type NavbarProps = StateProps &
  DispatchProps & {
    children:
      | React.ReactComponentElement<any, any>
      | React.ReactComponentElement<any, any>[];
  };

const mapStateToProps = (state: State): StateProps => ({
  name: getNavbarName(state),
  userAccountType: getUserAccountType(state)!,
  showRegionLink: !isPlurallApp(),
  hasLiveSubscription: hasLiveSubscription(state),
  isTeacher: isSchoolTeacher(state),
  isParent: isSchoolParent(state),
  locale: getHelpLinkRegionCode(state),
  region: getRegion(state)!
});

const mapDispatchToProps = (dispatch: any) => ({
  signOut: () => dispatch(signOut())
});

const makeConnectedNavbar = (
  Component: React.ComponentType<any>
): React.ComponentType<any> =>
  withRouter(connect(mapStateToProps, mapDispatchToProps)(toJS(Component)));

export default makeConnectedNavbar;
